



































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import InputTextBox from "./AnswerOptions/InputTextBoxMulti.vue";
import ButtonProfi from "../ButtonProfi.vue";
import Description from "../Description.vue";
import Headline from "../Headline.vue";
import { Question, AnswerOption } from "../../types/DataSource";

@Component({
  components: {
    "input-text-box": InputTextBox,
    "button-profi": ButtonProfi,
    "description-profi": Description,
    "headline-profi": Headline
  }
})
export default class TextBoxQuestion extends Vue {
  @Prop({ default: () => [] }) private selected!: string[];
  @Prop({ default: "info-circle" }) private icon!: string;
  @Prop({ required: true }) private question!: Question;

  private selectedIds = this.selected;
  private get buttonWidth() {
    return 40 + 60 + this.maxAnswerTitleLength * 15;
  }

  private get maxAnswerTitleLength(): number {
    return this.question.answers.reduce(
      (
        previousAnswerOption: AnswerOption,
        currentAnswerOption: AnswerOption
      ): AnswerOption => {
        return previousAnswerOption.title.length >
          currentAnswerOption.title.length
          ? previousAnswerOption
          : currentAnswerOption;
      }
    ).title.length;
  }

  mounted() {
    if (this.selectedIds[0] === null) {
      this.selectedIds = [];
    }
  }

  get dynamicStyles() {
    return {
      "--button-width": this.buttonWidth + "px"
    };
  }

  get descriptionText() {
    const latestAnswer = this.question.answers.find(
      element => element.id == this.selectedIds[this.selectedIds.length - 1]
    );

    if (latestAnswer != undefined) {
      return latestAnswer.description;
    }

    return "";
  }

  get buttonDisabled() {
    return this.selectedIds.length === 0;
  }

  get descriptionVisible() {
    return this.selectedIds.length !== 0;
  }

  @Emit("next")
  private confirmAnswer(): string[] {
    return this.selectedIds;
  }
}
